import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";

// fetch thunk …
export const fetchSubscriptionPlans = createAsyncThunk(
  "subscriptions/fetchAdminPlans",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await api.get("/admin/subscriptions/plans", {
        params,
      });

      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch subscription plans" }
      );
    }
  }
);

// delete thunk
export const deleteSubscriptionPlan = createAsyncThunk(
  "subscriptions/deletePlan",
  async (planId, { rejectWithValue }) => {
    try {
      // NOTE: no extra quotes, plain ID-010
      const response = await api.delete(
        `/admin/subscriptions/plans/${planId}`
      );

      // You decide what to return. We’ll need the ID to update state.
      return {
        planId,
        message: response.data?.message || "Subscription plan deleted",
      };
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to delete subscription plan" }
      );
    }
  }
);

// update thunk -> patch
export const updateSubscriptionPlan = createAsyncThunk(
  "subscriptions/updatePlan",
  async (updatedPlan, { rejectWithValue }) => {
    try {
      // Send PATCH request to backend with the updated plan data
      const response = await api.patch(
        `/admin/subscriptions/plans/${updatedPlan._id}`,
        updatedPlan
      );

      // Return the response data on success
      return response.data.data;
    } catch (error) {
      // Handle any error and return the error message
      return rejectWithValue(
        error.response?.data || { message: "Failed to update subscription plan" }
      );
    }
  }
);
